// extracted by mini-css-extract-plugin
export var content = "_vx-1";
export var wrapper = "_vx-0";